(() => {
  const instances = new Map();

  const prefersReducedMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const createSwiper = (el) => {
    if (typeof Swiper === "undefined" || instances.has(el)) return;

    const slideCount = el.querySelectorAll(".swiper-slide").length;
    const enableAutoplay =
      el.dataset.autoplay === "true" && slideCount > 1 && !prefersReducedMotion();
    const interval = Number(el.dataset.interval) || 4000;
    const paginationEl = el.querySelector(".ctr-pdp-art__review-pagination");

    const options = {
      slidesPerView: 1,
      spaceBetween: 16,
      autoHeight: true,
      grabCursor: slideCount > 1,
      watchOverflow: true,
      a11y: {
        enabled: true,
      },
    };

    if (paginationEl && slideCount > 1) {
      options.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    if (enableAutoplay) {
      options.autoplay = {
        delay: interval,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    instances.set(el, new Swiper(el, options));
  };

  const destroySwiper = (el) => {
    const swiper = instances.get(el);
    if (!swiper) return;
    swiper.destroy(true, true);
    instances.delete(el);
  };

  const initInRoot = (root) => {
    if (!root) return;

    const nodes = [];
    if (root.matches?.("[data-ctr-pdp-art-reviews]")) nodes.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll("[data-ctr-pdp-art-reviews]").forEach((node) => {
        nodes.push(node);
      });
    }

    nodes.forEach(createSwiper);
  };

  const unloadInRoot = (root) => {
    if (!root) return;

    const nodes = [];
    if (root.matches?.("[data-ctr-pdp-art-reviews]")) nodes.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll("[data-ctr-pdp-art-reviews]").forEach((node) => {
        nodes.push(node);
      });
    }

    nodes.forEach(destroySwiper);
  };

  // Load the complementary card as soon as the section is ready instead of waiting
  // for the theme's IntersectionObserver (which never fires in hidden documents).
  const eagerLoadComplementary = (root) => {
    if (!root?.querySelectorAll) return;
    root.querySelectorAll("product-recommendations.ctr-complementary").forEach((el) => {
      if (el.dataset.ctrEagerLoaded) return;
      el.dataset.ctrEagerLoaded = "true";
      customElements.whenDefined("product-recommendations").then(() => {
        if (typeof el.loadRecommendations !== "function") return;
        el.observer?.unobserve?.(el);
        el.loadRecommendations(el.dataset.productId);
      });
    });
  };

  const initAll = () => {
    initInRoot(document);
    eagerLoadComplementary(document);
  };

  const onBlockSelect = (event) => {
    const slide = event.target?.closest?.(".swiper-slide");
    const carousel = event.target?.closest?.("[data-ctr-pdp-art-reviews]");
    if (!slide || !carousel) return;

    const swiper = instances.get(carousel);
    if (!swiper) return;

    const index = Array.from(carousel.querySelectorAll(".swiper-slide")).indexOf(slide);
    if (index < 0) return;

    swiper.slideTo(index);
    if (swiper.autoplay?.running) swiper.autoplay.stop();
  };

  const onBlockDeselect = (event) => {
    const carousel = event.target?.closest?.("[data-ctr-pdp-art-reviews]");
    if (!carousel || carousel.dataset.autoplay !== "true") return;
    if (prefersReducedMotion()) return;

    const swiper = instances.get(carousel);
    if (!swiper?.autoplay) return;
    swiper.autoplay.start();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initInRoot(event.target);
    eagerLoadComplementary(event.target);
  });
  document.addEventListener("shopify:section:unload", (event) => unloadInRoot(event.target));
  document.addEventListener("shopify:section:reorder", initAll);
  document.addEventListener("shopify:block:select", onBlockSelect);
  document.addEventListener("shopify:block:deselect", onBlockDeselect);
})();
